import React, { PropTypes } from 'react'
import './style.less'

function ProductCard({ page }) {
	const specs = Object.keys(page.data.Specifications).map((label) => {
		if (label !== 'Model') {
			const value = page.data.Specifications[label]
			return (
				<tr key={label}>
					<td width="40%">{label}</td>
					<td dangerouslySetInnerHTML={{__html: value }} />
				</tr>
			)
		}
	})

	return (
		<div className="col-md-4 col-sm-6 col-xs-12">
			<a href={page.path}>
				<div className="product-row">
					<h3>{page.data.Specifications.Model}</h3>
					<img src={page.data.Thumbnail} width="100%" />
					<table>
						<tbody>
							{specs}
						</tbody>
					</table>
				</div>
			</a>
		</div>
	)
}

ProductCard.propTypes = {

}

ProductCard.defaultProps = {

}

export default ProductCard



// WEBPACK FOOTER //
// ../components/ProductCard/index.js